var CalculatorUtil = {};

CalculatorUtil.calculateHours = function(params) {
  var doneHours = params.doneHoursFromCurrentCategory,
    doneUnstructuredHours = params.doneUnstructuredHoursFromCurrentCategory,
    plannedHours = params.plannedHoursFromCurrentCategory,
    localShoppingHours = params.localShoppingHours;

  return {
    main: {
      doneHours: doneHours,
      doneUnstructuredHours: doneUnstructuredHours,
      plannedHours: plannedHours,
      shoppingHours: localShoppingHours
    }
  };
};

module.exports = CalculatorUtil;
